

const displayEMSImageList: any = [];
const uploadEMSImageList: any = [];
const EKGDisplayImageList: any = [];
const EKGUploadImageList: any = [];

export const EMSImageService = {
  displayEMSImageList,
  uploadEMSImageList,
  EKGDisplayImageList,
  EKGUploadImageList,
};
